import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalLayout = ({ eyebrow, title, updated, children, testId }) => {
  return (
    <main data-testid={testId} className="relative bg-white pb-24 pt-28 lg:pt-36">
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-72 bg-gradient-to-b from-brand-light/60 to-white" />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-ink/50 transition-colors hover:text-brand"
        >
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8"
        >
          {eyebrow && (
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-brand-700">
              <span className="h-1.5 w-1.5 rounded-full bg-brand" />
              {eyebrow}
            </span>
          )}
          <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
            {title}
          </h1>
          {updated && <p className="mt-4 text-sm text-ink/45">Dernière mise à jour&nbsp;: {updated}</p>}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="legal-prose mt-12 space-y-8 text-ink/70"
        >
          {children}
        </motion.div>
      </div>
    </main>
  );
};

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="mb-3 font-display text-xl font-bold text-ink">{title}</h2>
    <div className="space-y-3 text-base leading-relaxed">{children}</div>
  </section>
);
